import React, { Fragment, useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import Card from '../../card'
import CardTitle from '../cardHeader/cardTitle'
// import CardHeader from '../cardHeader'
import CardBase from './card/card'
import Radio from './radio/radio'
import Input from './input/input'

import styles from './_cardSendDocuments.scss'

const optsToSendDocs = {
  '': '',
  ANOTHER_EMAIL: 'ANOTHER_EMAIL',
  REGISTERED_EMAIL: 'REGISTERED_EMAIL'
}

const CardSendDocuments = ({ email, defaultOption, onChange }) => {
  const [radioEmailSelected, setRadioEmailSelected] = useState(
    email ? null : optsToSendDocs.ANOTHER_EMAIL
  )
  const [inputValue, setInputValue] = useState('')
  const [errorMessage, setErrorMessage] = useState('')

  useEffect(() => {
    console.log('render inicial', defaultOption)
    if (defaultOption) setRadioEmailSelected(defaultOption)
  }, [])

  useEffect(() => {
    if (radioEmailSelected === optsToSendDocs.ANOTHER_EMAIL)
      onChange({
        email: inputValue,
        option: radioEmailSelected,
        errors: errorMessage
      })
  }, [inputValue])

  useEffect(() => {
    console.log('radioEmailSelected cambió', radioEmailSelected)
    if (!radioEmailSelected || !email) return

    let emailToSendDocs = ''

    if (radioEmailSelected === optsToSendDocs.REGISTERED_EMAIL)
      emailToSendDocs = { email, errors: '' }
    else if (radioEmailSelected === optsToSendDocs.ANOTHER_EMAIL)
      emailToSendDocs = { email: inputValue, errors: errorMessage }

    onChange({ ...emailToSendDocs, option: radioEmailSelected })
  }, [radioEmailSelected])

  const handleChangeInput = (ev) => {
    const errors = ev.errors
    const isWithFormatError =
      (errors && errors.flatMap((el) => el.type).includes('FORMAT')) || false

    setInputValue(ev.target.value)

    if (isWithFormatError) setErrorMessage('Formato incorrecto')
    else setErrorMessage('')
  }

  return (
    <CardBase title='Envío de documentos'>
      <section className={styles['CreditInfo--form-documents-send']}>
        Al firmar electrónicamente, te enviaremos tu contrato al siguiente
        email:
        <article className={styles['CreditInfo--emails-options']}>
          {email && (
            <Radio
              id={`rd-${optsToSendDocs.REGISTERED_EMAIL}`}
              name={`email`}
              value={optsToSendDocs.REGISTERED_EMAIL}
              label={`Email registrado (${email})`}
              isChecked={radioEmailSelected === optsToSendDocs.REGISTERED_EMAIL}
              onCheck={(value) => setRadioEmailSelected(value)}
            />
          )}
          <article className={styles['CreditInfo--another-email']}>
            {email && (
              <Radio
                id={`rd-${optsToSendDocs.ANOTHER_EMAIL}`}
                name={`email`}
                value={optsToSendDocs.ANOTHER_EMAIL}
                label='Enviar a otra cuenta de email'
                isChecked={radioEmailSelected === optsToSendDocs.ANOTHER_EMAIL}
                onCheck={(value) => setRadioEmailSelected(value)}
              />
            )}
            {radioEmailSelected === optsToSendDocs.ANOTHER_EMAIL && (
              <article className={styles['CreditInfo--input-another-email']}>
                <Input
                  name='email'
                  value={inputValue}
                  label={email && 'Email'}
                  type='email'
                  maxLength={150}
                  hintText='Este email no reemplaza tus datos actuales'
                  errorMessage={errorMessage}
                  onChange={handleChangeInput}
                  required
                />
              </article>
            )}
          </article>
        </article>
      </section>
    </CardBase>
  )
}

CardSendDocuments.defaultProps = {
  onChange: () => null,
  defaultOption: '',
  email: ''
}

CardSendDocuments.propTypes = {
  email: PropTypes.string,
  defaultOption: PropTypes.oneOf(Object.keys(optsToSendDocs)),
  onChange: PropTypes.func
}

export default CardSendDocuments
